import styled from 'styled-components';

export const Header = styled.div`
  background-color: #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 55px;
  padding: 0 14px;

  > * {
    align-items: center;
    display: flex;
  }
`;

export const MenuButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 40px;
  width: 40px;
  border-left: 1px solid hsla(0, 0%, 100%, 0.24);
  color: #ffff;

  &:hover {
    background: hsla(0, 0%, 100%, 0.12);
  }

  svg {
    color: #ebedf0;
  }
`;

export const RightLogo = styled.img`
  margin: 0 8px;
`;

export const Menu = styled.ul<{ shouldDisplay: boolean }>`
  display: flex;
  justify-content: flex-end;
  flex-flow: column;
  position: absolute;
  opacity: 1;
  right: 0;
  top: 100%;
  opacity: ${({ shouldDisplay }) => (shouldDisplay ? '1' : '0')};
  z-index: ${({ shouldDisplay }) => (shouldDisplay ? '1000' : '-1000')};
  transition: all 0.5s;
  color: #ebedf0;
  list-style-type: none;
  width: 250px;
  padding: 0;
  margin: 0;

  li {
    font-size: 14px;
    text-align: right;
    background: #000000;
    &.selected {
      background: rgba(98, 98, 98, 1);
    }
    &:hover {
      background: rgba(125, 125, 125, 1);
    }

    > * {
      padding: 15px;
      display: block;
      text-decoration: none;
      color: inherit;
    }
  }
`;

export const Logo = styled.div`
  img {
    height: 16px;
  }
`;
